import { Brain, ShieldCheck, RefreshCcw, ArrowRight } from 'lucide-react';

/**
 * Hero / value-prop block for the block-explorer landing page.
 * Tailwind v3 utility classes.
 */
export const ValueProposition = () => {
  return (
    <section className="flex max-w-[640px] flex-col justify-center space-y-10">
      {/* ── Headline + sub-copy ────────────────────────────────────── */}
      <header className="space-y-3">
        <h2 className="text-4xl font-extrabold tracking-tight sm:text-6xl">
          See who owns every address.
        </h2>
        <p className="text-gray-600 md:text-lg">
          Our clustering algorithms <span className="font-semibold">&amp;</span>{' '}
          human field research map
          <span className="whitespace-nowrap">
            {'\u00A0'}250 M+{'\u00A0'}
          </span>
          addresses across Bitcoin, Ethereum and Tron —
          <span className="whitespace-nowrap">{'\u00A0'}more coming.</span>{' '}
          Start free with <strong>100 address lookups / month</strong> for major
          exchange.
        </p>
      </header>

      {/* ── Feature list ───────────────────────────────────────────── */}
      <ul className="space-y-7">
        <li className="flex items-start gap-4">
          <div className="rounded-full bg-purple-100 p-2">
            <Brain className="h-6 w-6 text-purple-600" />
          </div>
          <div>
            <h3 className="font-semibold">Advanced Clustering</h3>
            <p className="text-gray-600">
              Change-address heuristics, peel-chain detection and dusting
              analytics merge raw addresses into real-world entities.
            </p>
          </div>
        </li>

        <li className="flex items-start gap-4">
          <div className="rounded-full bg-purple-100 p-2">
            <ShieldCheck className="h-6 w-6 text-purple-600" />
          </div>
          <div>
            <h3 className="font-semibold">Human-Verified Intel</h3>
            <p className="text-gray-600">
              Researchers active in global Telegram, OTC and dark-web forums
              surface hard-to-find mixers, rogue exchanges and mule networks.
            </p>
          </div>
        </li>

        <li className="flex items-start gap-4">
          <div className="rounded-full bg-purple-100 p-2">
            <RefreshCcw className="h-6 w-6 text-purple-600" />
          </div>
          <div>
            <h3 className="font-semibold">Continuously Updated</h3>
            <p className="text-gray-600">
              New tags and clusters are pushed live frequently, keeping your
              view of the chain current.
            </p>
          </div>
        </li>
      </ul>

      {/* ── Free tier call-out ─────────────────────────────────────── */}
      <aside className="rounded-lg border border-purple-100 bg-purple-50 p-5">
        <p className="text-sm text-purple-800">
          <strong>Free Tier —</strong> 100 lookups / month, real-time updates,
          covers whitelisted entities like Coinbase, Kraken &amp; Binance. Need
          sanctioned clusters, darknet markets or higher volume?{' '}
          <a
            href="https://www.elementus.io/schedule"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center font-medium text-purple-700 hover:underline"
          >
            Talk to sales <ArrowRight className="ml-1 h-4 w-4" />
          </a>
        </p>
      </aside>
    </section>
  );
};
